/** Static paths served from /assets/ (web-frontend/assets/ → dist/assets/). */
export const ASSETS = {
    logo: '/assets/logo.svg',
    logoFull: '/assets/logo-full.svg',
    favicon32: '/assets/favicon-32.png',
    appleTouchIcon: '/assets/apple-touch-icon.png',
};
